export function repDisplayName(name: string, isInactive: boolean): string {
  return isInactive ? `${name} (Inactive)` : name;
}
